<template>
  <img class="logo" :src="require(`@/assets/images/logos/${logoName(theme)}.webp`)" />
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      theme: 'general/theme',
    }),
  },
  methods: {
    logoName(theme) {
      switch (theme) {
        default:
          return 'default'
      }
    }
  }
};
</script>
